// /opt/ptg01-v1/front-extranet/app/(dashboard)/error.tsx
// Error Boundary App Router — catche les erreurs runtime côté client uniquement
// (pour les erreurs serveur, voir le global-error.tsx racine).
//
// Charte respectée : bg-white, border-2 border-[#000091]/25 rounded-2xl, bleu Nexvia.
'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { AlertCircle, RefreshCw, Home } from 'lucide-react';

export default function DashboardError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        // Log côté client (en prod, à brancher sur Sentry/Datadog)
        console.error('[DashboardError]', error);
    }, [error]);

    return (
        <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center p-6 bg-white">
            <div className="max-w-md w-full bg-white border-2 border-[#000091]/25 rounded-2xl shadow-[0_1px_3px_rgba(0,0,0,0.04)] p-6 text-center">
                <div className="w-14 h-14 rounded-full bg-rose-50 text-rose-600 flex items-center justify-center mx-auto mb-4">
                    <AlertCircle className="w-7 h-7" strokeWidth={1.75} />
                </div>
                <h1 className="text-[18px] font-black text-slate-900 mb-2">Une erreur est survenue</h1>
                <p className="text-[13px] text-slate-600 leading-relaxed">
                    Quelque chose ne s’est pas passé comme prévu. L’équipe Nexvia a été notifiée.
                </p>
                {error.digest && (
                    <p className="text-[10px] text-slate-400 mt-3 font-mono">
                        Référence : {error.digest}
                    </p>
                )}
                <div className="mt-6 flex items-center gap-2 justify-center">
                    <button
                        onClick={reset}
                        className="inline-flex items-center gap-1.5 h-10 px-4 text-[13px] font-semibold rounded-lg bg-[#000091] text-white hover:bg-[#1e40af] transition-colors"
                    >
                        <RefreshCw className="w-4 h-4" />Réessayer
                    </button>
                    <Link
                        href="/"
                        className="inline-flex items-center gap-1.5 h-10 px-4 text-[13px] font-semibold rounded-lg border-2 border-slate-200 text-slate-700 hover:bg-slate-50 transition-colors"
                    >
                        <Home className="w-4 h-4" />Tableau de bord
                    </Link>
                </div>
            </div>
        </div>
    );
}
